var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"input-props":{class: "base-datepicker"},"masks":_vm.masks},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }